import React from 'react';
import styled from '@emotion/styled/macro';
import vars from '../../variables';
import TableHeader from './sub-components/table-header';

const Table = ({ tableHeaderData, children, className }) => {
  return (
    <table className={className}>
      <TableHeader data={tableHeaderData} />
      <tbody>{children}</tbody>
    </table>
  );
};

// === Table CSS ===
const StyledTable = styled(Table)`
  margin: ${vars.spacingS} 0;
  border-collapse: collapse;
  tr {
    td,
    th {
      text-align: left;
    }
    td {
      ${vars.fontSize2}
      vertical-align: baseline;
      padding: ${vars.spacingM} ${vars.spacingS};
      border-bottom: 1px solid ${vars.transparentBorderGrey};
      &:hover: {
        border: 0;
      }
    }
    th {
      ${vars.fontSize1}
      padding: ${vars.spacingS};
      vertical-align: bottom;
      background-color: ${vars.greyHavens};
    }
  }
`;

export default StyledTable;
